/**
 * Application configuration constants.
 */

/** Timeout configurations in milliseconds */
export const TIMEOUTS = {
  /** Default API request timeout */
  API_REQUEST: 30000,
} as const;
